document.addEventListener('DOMContentLoaded', function() {
  // Cache DOM elements
  const drawerContainer = document.getElementById('Details-menu-drawer-container');
  const menuToggle = drawerContainer.querySelector('summary');
  const allDetails = document.querySelectorAll('.menu-drawer__navigation details');
  const submenuPanels = document.querySelectorAll('.drawer-panel');
  const slideMenuItems = document.querySelectorAll('.has-children');
  const backButtons = document.querySelectorAll('[data-action="back"]');
  
  // Toggle menu function that keeps the page scrollable
  function toggleMenu(isOpen) {
    drawerContainer.classList.toggle('details-open', isOpen);
    menuToggle.setAttribute('aria-expanded', isOpen);
    
    // If closing the menu, reset panels
    if (!isOpen) {
      setTimeout(() => {
        submenuPanels.forEach(panel => panel.classList.remove('active'));
      }, 300);
    }
  }
  
  // Optimized details animation handler using requestAnimationFrame
  allDetails.forEach(detail => {
    detail.addEventListener('toggle', function() {
      const content = this.querySelector('ul');
      if (!content) return;
      
      if (this.open) {
        content.style.maxHeight = '0px';
        requestAnimationFrame(() => {
          content.style.maxHeight = `${content.scrollHeight}px`;
          setTimeout(() => content.style.maxHeight = 'none', 500);
        });
      } else {
        content.style.maxHeight = `${content.scrollHeight}px`;
        requestAnimationFrame(() => content.style.maxHeight = '0px');
      }
    });
  });
  
  // Event delegation for panel navigation
  document.addEventListener('click', function(e) {
    const hasChildrenItem = e.target.closest('.has-children');
    if (hasChildrenItem) {
      const targetPanel = document.getElementById(hasChildrenItem.getAttribute('data-target'));
      if (targetPanel) targetPanel.classList.add('active');
    }
    
    const backButton = e.target.closest('.back-button');
    if (backButton) {
      const parentPanel = backButton.closest('.drawer-panel');
      if (parentPanel) parentPanel.classList.remove('active');
    }
  });
  
  // Main event listeners
  drawerContainer.addEventListener('toggle', () => toggleMenu(drawerContainer.open));
  
  // Add event listener for menu overlay if it exists
  const menuOverlay = document.getElementById('menu-overlay');
  if (menuOverlay) {
    menuOverlay.addEventListener('click', () => drawerContainer.open = false);
  }
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawerContainer.open) {
      drawerContainer.open = false;
    }
  });
  
  // Touch gestures with better performance
  let touchStartX = 0;
  const swipeThreshold = 50;
  
  document.addEventListener('touchstart', e => {
    touchStartX = e.changedTouches[0].screenX;
  }, {passive: true});
  
  document.addEventListener('touchend', e => {
    const touchEndX = e.changedTouches[0].screenX;
    
    // Swipe left to close
    if (drawerContainer.open && !document.querySelector('.drawer-panel.active') && 
        touchEndX < touchStartX - swipeThreshold) {
      drawerContainer.open = false;
    }
    
    // Swipe right to go back from panel
    const activePanel = document.querySelector('.drawer-panel.active');
    if (activePanel && touchEndX > touchStartX + swipeThreshold) {
      activePanel.classList.remove('active');
    }
  }, {passive: true});
});
